// Notification schemas — M8-S3.
// Her notification bir user'a bağlıdır; type + title + body + url +
// readAt (null → okunmamış). SSE ile realtime push (pg-notify).

import { z } from "zod";

// Notification type enum — FE'de icon + color'a map'lenir, trigger'da set edilir.
export const NOTIFICATION_TYPES = [
  "project_assigned",
  "section_approved",
  "section_rejected",
  "project_completed",
  "generation_failed",
  "generation_succeeded",
  "budget_alert",
  "queue_paused",
  "queue_resumed",
  "user_invited",
  // Müşteri katılımcı rolü (plan: 2026-07-23-musteri-katilimci-rolu)
  "participant_submitted",
  // Geçmiş Rapor Aktarımı (plan: 2026-09-24-report-import)
  "report_import_completed",
  "report_import_failed",
  // KPI modülü M16 — müşteri döngüsü (plan: 2026-09-08-kpi-module T19, DR6)
  "kpi_value_verified",
  "kpi_clarification_requested",
  "kpi_client_submitted",
  // TODO-KPI-21 — danışman müşterinin girdiği değeri değiştirdi ("danışman düzeltti", DR8)
  "kpi_value_corrected",
  // Dalga 2 K10 — müşteri/denetçi notu (değer değişmeden)
  "kpi_client_note",
  // Dalga 3 D3-3 — danışman hücre notu iş parçacığında yanıt verdi (müşteri yazarına)
  "kpi_consultant_reply",
  // Rapor Tutarlılık Denetimi (plan: 2026-10-22-rapor-tutarlilik-denetimi)
  "report_check_done",
  "report_check_failed",
] as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

export const NotificationSchema = z.object({
  id: z.string().uuid(),
  type: z.string(),
  title: z.string(),
  body: z.string().nullable(),
  url: z.string().nullable(),
  readAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type Notification = z.infer<typeof NotificationSchema>;

export const NotificationListResponseSchema = z.object({
  notifications: z.array(NotificationSchema),
  unreadCount: z.number().int().nonnegative(),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
});
export type NotificationListResponse = z.infer<typeof NotificationListResponseSchema>;

export const NotificationListQuerySchema = z.object({
  unreadOnly: z.coerce.boolean().default(false),
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().min(10).max(100).default(20),
});
export type NotificationListQuery = z.infer<typeof NotificationListQuerySchema>;
